import axios from 'axios'
import { env } from '../config/env'

declare module 'axios' {
  export interface AxiosRequestConfig {
    activeSpinner?: boolean;
  }
}

export const psgApi = axios.create({
  baseURL: env.psg.apiUrl
})

export type TResponse<T> = {
  succeeded: boolean;
  data: T | null;
  message: string | null;
}
